import { IdentityService } from '../index'

// importing this way uses loader's built-in style adding mechanism:
import './loginradius/styles/buttons.scss' // tslint:disable-line: no-import-side-effect

// importing partial(s) here still gives us a string but is automatically part of this chunk:
// tslint:disable-line: no-import-side-effect
import signIn from './loginradius/templates/buttons/signin.htm'
import signOut from './loginradius/templates/buttons/signout.htm'

export class IdentityButtons {
    public static initDOM(siteName = '') {
        const btnContainers = document.querySelectorAll(`[${IdentityService.DOM.attrs.btns}]`)

        for(const container of btnContainers) {
            const ssoBtns = siteName ? [signIn] : [signIn, signOut]
            const ssoBtnHtml = ssoBtns.join('')

            this.addHtml(container, ssoBtnHtml)
        }
    }

    public static addHtml(container: Element, html: string) {
        container.insertAdjacentHTML('afterbegin', html)
    }
}
